var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { Auth } from '@aws-amplify/auth';
import { zauvu } from '../config';
export class ApiClient {
    post(path, data, configOverride) {
        return __awaiter(this, void 0, void 0, function* () {
            const post = () => __awaiter(this, void 0, void 0, function* () {
                return axios.post(this.buildBasePath(path), data, Object.assign(Object.assign({}, configOverride), (yield this.getBaseConfig())));
            });
            return this.axiosWrapper(post);
        });
    }
    get(path, data, configOverride) {
        return __awaiter(this, void 0, void 0, function* () {
            const get = () => __awaiter(this, void 0, void 0, function* () {
                return axios.get(this.buildBasePath(path), Object.assign(Object.assign({ data }, configOverride), (yield this.getBaseConfig())));
            });
            return this.axiosWrapper(get);
        });
    }
    delete(path, data, configOverride) {
        return __awaiter(this, void 0, void 0, function* () {
            const deleteFunc = () => __awaiter(this, void 0, void 0, function* () {
                return axios.delete(this.buildBasePath(path), Object.assign(Object.assign({ data }, configOverride), (yield this.getBaseConfig())));
            });
            return this.axiosWrapper(deleteFunc);
        });
    }
    getBaseConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            const jwt = yield this.getToken();
            return {
                headers: {
                    Authorization: `Bearer ${jwt}`
                },
                validateStatus: (status) => {
                    return status >= 200 && status < 300;
                }
            };
        });
    }
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const session = yield Auth.currentSession();
            return session.getIdToken().getJwtToken();
        });
    }
    buildBasePath(path) {
        // Validate path structure
        const firstLetter = path.length > 0 ? path.charAt(0) : undefined;
        if (!firstLetter)
            throw new Error(`Path, ${path}, is undefined`);
        if (firstLetter !== '/')
            throw new Error(`Path ${path} must begin with /`);
        return `${zauvu.getConfig().REST_API_URL}${path}`;
    }
    isAxiosError(error) {
        // @ts-expect-error We do a check for the error
        return error !== undefined && error.isAxiosError === true;
    }
    axiosWrapper(func) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return {
                    isOk: true,
                    statusCode: '200',
                    data: yield func()
                };
            }
            catch (error) {
                if (this.isAxiosError(error)) {
                    return {
                        isOk: false,
                        statusCode: error.code,
                        errorMessage: JSON.stringify(error.message)
                    };
                }
                throw error;
            }
        });
    }
}
export const client = new ApiClient();
